import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, useTheme } from '@mui/material';
import { ArrowCircleLeft, ArrowCircleRight } from 'iconsax-react';
import React from 'react';
export const EditInfoStepper = ({ steps, activeStep, setActiveStep, trigger }) => {
    const handleNext = () => {
        trigger().then((isValid) => {
            if (isValid) {
                if (activeStep < steps.length - 1) {
                    setActiveStep((prevStep) => prevStep + 1);
                }
            }
        });
    };
    const handleBack = () => {
        if (activeStep > 0) {
            setActiveStep((prevStep) => prevStep - 1);
        }
    };
    const theme = useTheme();
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            mb: 2
        }, children: [_jsx(IconButton, { disabled: activeStep === 0, onClick: handleBack, color: 'primary', children: _jsx(ArrowCircleLeft, {}) }), _jsx(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    flex: 1,
                    margin: '0 8px'
                }, children: steps.map((step, index) => (_jsx(Box, { sx: {
                        flex: 1,
                        height: '8px',
                        backgroundColor: index <= activeStep ? theme.palette.primary.main : '#e0e0e0',
                        margin: '0 8px',
                        borderRadius: '4px'
                    } }, index))) }), _jsx(IconButton, { disabled: activeStep === steps.length - 1, onClick: handleNext, color: 'primary', children: _jsx(ArrowCircleRight, {}) })] }));
};
